import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import { Header } from './components/header';

export const GlobalLayout = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Layout>
        <Outlet />
      </Layout>
    </Layout>
  );
};
